import snakify from "snakify-ts";
import { CustomerBodySchema, DefaultService } from "../generated";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Camelize } from "camelize-ts";
import { toaster } from "../components/toaster";

export const useCustomerUpdate = (customerNumber: number | null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["customerCreate"],
    mutationFn: (data: Camelize<CustomerBodySchema>) =>
      DefaultService.fakturCustomersViewsCustomerUpdate({
        customerNumber: customerNumber || 0,
        requestBody: snakify(data),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["customerSearch"] });
      queryClient.invalidateQueries({ queryKey: ["customer", customerNumber] });
      toaster.success({ title: "Kunde oppdatert!" });
    },
  });
};
